import {BillingDiscount, getPrivateAxios} from '@blesk-frontend/api';

export const fetchBillingDiscounts = async () => {
  const {data} = await getPrivateAxios().get<BillingDiscount[] | null>('/billing/discounts');
  return data || null;
};
